export default "__VITE_ASSET__DVgpOOHC__"